import { render, staticRenderFns } from "./RaceDetail.vue?vue&type=template&id=3945e273&scoped=true&"
import script from "./RaceDetail.vue?vue&type=script&lang=js&"
export * from "./RaceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3945e273",
  null
  
)

export default component.exports